<app-dashboard-header></app-dashboard-header>

<div class="availability-content">
  <div class="page-header">
    <button mat-icon-button color="primary" (click)="goBack()" class="back-button">
      <mat-icon>arrow_back</mat-icon>
    </button>
    <h1 class="page-title">
      Resource Availability
      <span *ngIf="resource" class="resource-title-info">
        - {{ resource.name }}
      </span>
    </h1>
  </div>
  
  <mat-card>
    <div class="card-header">
      <h2>
        Manage Availability
      </h2>
      <div class="header-actions">
        <button mat-flat-button class="action-button accent" (click)="openAddDialog()">
          <mat-icon>add</mat-icon>
          Add Availability
        </button>
      </div>
    </div>

    <mat-progress-spinner *ngIf="loading" mode="indeterminate" diameter="40"></mat-progress-spinner>

    <div *ngIf="error" class="error-message">
      {{ error }}
    </div>

    <div *ngIf="!loading" class="availability-container">
      <div class="days-grid">
        <div *ngFor="let day of daysOfWeek" class="day-container">
          <div class="day-header">
            <h3>{{ day.name }}</h3>
          </div>
          
          <div class="day-slots">
            <div *ngIf="getAvailabilitiesForDay(day.value).length === 0" class="no-slots">
              No availability slots
            </div>
            
            <div class="time-slots-container">
              <div *ngFor="let slot of getAvailabilitiesForDay(day.value)" class="time-slot">
                <div class="time-range">
                  {{ formatTime(slot.startTime) }} - {{ formatTime(slot.endTime) }}
                </div>
                <div class="slot-actions">
                  <button mat-icon-button color="accent" [matMenuTriggerFor]="copyMenu" matTooltip="Copy options">
                    <mat-icon>content_copy</mat-icon>
                  </button>
                  <mat-menu #copyMenu="matMenu">
                    <button mat-menu-item (click)="copyToAllDays(slot, false)">
                      <mat-icon>content_copy</mat-icon>
                      <span>Copy to all days</span>
                    </button>
                    <button mat-menu-item (click)="copyToAllDays(slot, true)">
                      <mat-icon>work</mat-icon>
                      <span>Copy to weekdays only</span>
                    </button>
                  </mat-menu>
                  <button mat-icon-button color="primary" matTooltip="Edit" (click)="openEditDialog(slot)">
                    <mat-icon>edit</mat-icon>
                  </button>
                  <button mat-icon-button color="warn" matTooltip="Delete" (click)="deleteAvailability(slot)">
                    <mat-icon>delete</mat-icon>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </mat-card>
</div>

<app-dashboard-footer></app-dashboard-footer>
